import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./BookingSeats.css";
import { useLocation } from "react-router-dom";
import language from "../../../../language";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { bookSeats } from "../../../../Redux/userReducer";
import { getUser } from "../../../../Redux/userReducer";
//mui
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useHistory } from "react-router-dom";
import { bookSeatsWithoutLogin } from "../../../../Redux/userReducer";
import SelectOption from "../../../../operator/components/form/SelectOption";
import { sendPriceData } from "../../../../Redux/userReducer";
// React Icons
import { TbSteeringWheel } from "react-icons/tb";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import {
  NonRegularPackageId,
  SelectPackageId,
  UpdateCurrentTrip,
  UpdateDepartureSeats,
  UpdateReturnSeats,
} from "../../../../actions/bookings";
import { useCallback } from "react";
import {
  UpdateDepartTripId,
  UpdateReturnTripId,
  SelectDepartTripId,
  SelectReturnTripId,
} from "../../../../actions/bookings";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BasicTabs = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.userReducer?.userData?.user);
  const departSeats = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripSeats
  );
  const returntSeats = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripSeats
  );
  const requestTripType = useSelector(
    (state) => state?.buses?.requesInfo?.tripType
  );
  const TotalPassenger = useSelector(
    (state) => state?.buses?.requesInfo?.totalPassenger
  );
  const requesInfo = useSelector((state) => state?.buses?.requesInfo);
  const data = useSelector((state) => state?.buses?.requesInfo);
  const [arraytwo, setArrayTwo] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [occupiedSeats, setOccupiedSeats] = useState([]);
  const busData = useSelector(
    (state) => state?.userReducer?.busData?.data?.bus
  );
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  useEffect(() => {
    const occupied = props.occupiedSeats || [];
    setOccupiedSeats(occupied);

    if (!props?.trip?.totalSeats) return;

    const arraySeats = [];
    for (let i = 0; i < props?.trip?.totalSeats; i++) {
      arraySeats.push({ seatNo: i + 1, flag: false });
    }

    // If user already selected seats, restore them
    if (selectedSeats.length > 0) {
      const updatedArray = arraySeats.map((seat) => ({
        ...seat,
        flag: selectedSeats.includes(seat.seatNo),
      }));
      setArrayTwo(updatedArray);
    } else {
      // Only do auto assignment if no selection yet
      assignSeats(arraySeats, occupied);
    }
  }, [props?.occupiedSeats, props?.trip?.totalSeats, TotalPassenger]);

  const assignSeats = (seatsArray, occSeats = occupiedSeats) => {
    const availableSeats = seatsArray.filter(
      (seat) => !occSeats.includes(seat.seatNo)
    );

    const seatsToAssign = availableSeats.slice(0, TotalPassenger);
    const assignedSeatNumbers = seatsToAssign.map((seat) => seat.seatNo);

    const updatedSeats = seatsArray.map((seat) => ({
      ...seat,
      flag: assignedSeatNumbers.includes(seat.seatNo),
    }));

    setArrayTwo(updatedSeats);
    setSelectedSeats(assignedSeatNumbers);
  };

  const seatSelectedClicked = (indexone, user, occuSeats) => {
    setArrayTwo((prevArrayTwo) => {
      const newSelectedSeats = [...selectedSeats]; // Copy of the current selected seats

      const updatedArray = prevArrayTwo.map((seat) => {
        if (seat.seatNo === user.seatNo) {
          if (seat.flag === true) {
            // Unselect the seat
            const filteredSeats = occupiedSeats?.filter(
              (num) => num !== user.seatNo
            );
            setOccupiedSeats(filteredSeats);
            const removeIndex = newSelectedSeats.indexOf(seat.seatNo);
            if (removeIndex > -1) {
              newSelectedSeats.splice(removeIndex, 1);
            }
            return { ...seat, flag: false };
          } else {
            // Select the seat
            if (newSelectedSeats.length >= TotalPassenger) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "You can only select seats equal to passengers. Increase passenger count to select more seats.",
              });
              return seat; // Return unchanged if limit is reached
            }
            newSelectedSeats.push(seat.seatNo);
            return { ...seat, flag: true };
          }
        }
        return seat; // Return unchanged seat
      });

      setSelectedSeats(newSelectedSeats); // Update the selected seats

      return updatedArray;
    });
  };

  // Default seat selection logic
  useEffect(() => {
    if (
      props?.modifyTrip &&
      props?.trip?._id === props?.oldbooking?.trip?._id
    ) {
      setArrayTwo((prevArrayTwo) => {
        const newSelectedSeats = [...selectedSeats];

        const updatedArray = prevArrayTwo.map((seat) => {
          if (props?.oldbooking?.seats.includes(seat.seatNo)) {
            if (!newSelectedSeats.includes(seat.seatNo)) {
              newSelectedSeats.push(seat.seatNo);
            }
            return { ...seat, flag: true }; // Mark as selected
          }
          return seat; // Return unchanged
        });

        setSelectedSeats(newSelectedSeats); // Sync selectedSeats
        return updatedArray;
      });
    }
  }, [
    props?.modifyTrip,
    props.trip._id,
    props?.oldbooking?.trip?._id,
    props?.oldbooking?.seats,
  ]);

  const [value, setValue] = React.useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [inputselectedSeats, setInputSelectedSeats] = useState(null);

  useEffect(() => {
    setInputSelectedSeats(data?.totalPassenger);
  }, [data]);

  console.log(selectedSeats, "123trip123", occupiedSeats, selectedSeats);
  const nextClicked = () => {
    if (props.seatSelection) {
      const priceData = {
        passengerNumber: selectedSeats.length,
        fareAmount: totalPrice,
        seatsAllocation: selectedSeats,
      };
      dispatch(UpdateDepartTripId(props?.tripId));
      dispatch(sendPriceData(priceData));
      dispatch(UpdateDepartureSeats(selectedSeats));
      dispatch(UpdateCurrentTrip(props.trip));
    } else {
      dispatch(UpdateDepartTripId(props?.tripId));
      dispatch(UpdateDepartureSeats(selectedSeats));
      dispatch(UpdateCurrentTrip(props.trip));
    }
  };

  const SelectedTrip = (e) => {
    if (props?.tripType == "Departure") {
      if (props?.trip?.type == "regular") {
        dispatch(
          SelectDepartTripId({ tripId: e._id, date: props?.departureTripDate })
        );
        dispatch(UpdateDepartureSeats(selectedSeats));
        props.setOpenModal(false);
      } else {
        dispatch(UpdateDepartTripId(e));
        dispatch(UpdateDepartureSeats(selectedSeats));
        props.setOpenModal(false);
      }
    } else {
      if (props?.trip?.type == "regular") {
        dispatch(
          SelectReturnTripId({ tripId: e._id, date: props?.returnTripDate })
        );
        dispatch(UpdateReturnSeats(selectedSeats));
        props.setOpenModal(false);
      } else {
        dispatch(UpdateReturnTripId(e));
        dispatch(UpdateReturnSeats(selectedSeats));
        props.setOpenModal(false);
      }
    }
  };

  const SelectedPackage = (trip, packageAccom = "") => {
    if (trip?.type === "regular") {
      console.log(trip?.type, "triptype");
      dispatch(
        SelectPackageId({
          packageId: trip._id,
          date: props?.departureTripDate,
          packageAccom,
        })
      );
      dispatch(UpdateReturnSeats(selectedSeats));
    } else {
      console.log(trip?.type, "triptypeextended");
      dispatch(NonRegularPackageId(trip, packageAccom));
      dispatch(UpdateCurrentTrip(trip));
      dispatch(UpdateDepartureSeats(selectedSeats));
    }

    history.push({
      pathname: "/client/passenger-detail",
    });
  };

  return (
    <>
      <TabPanel value={value} index={0}>
        <Grid
          container
          className="availableContainer"
          justifyContent="space-between"
        >
          <Grid
            item
            xl={6}
            lg={6}
            md={12}
            xs={12}
            align="center"
            className="mapContainer"
            style={{ padding: "20px 0" }}
          >
            <Tabs
              value={value}
              onChange={() => handleChange()}
              aria-label="basic tabs example"
            >
              {props.seatSelection ? (
                <Tab
                  label={
                    languageSelectedEnglish
                      ? "Available Seats"
                      : language.availableSeats
                  }
                  {...a11yProps(0)}
                />
              ) : (
                <Tab
                  label={
                    languageSelectedEnglish
                      ? "Select No of seats"
                      : language.availableSeats
                  }
                  {...a11yProps(0)}
                />
              )}
              {/* <Tab
                label={languageSelectedEnglish ? "Refunds" : language.refunds}
                {...a11yProps(1)}
              /> */}
            </Tabs>
            {props.seatSelection ? (
              <div>
                <div className="legendIndicator1">
                  <div className="emptySeat">
                    <p>
                      {languageSelectedEnglish
                        ? "Empty Seat:"
                        : language.emptySeat}
                    </p>
                    <div></div>
                  </div>
                  <div className="emptySeat2">
                    <p>
                      {languageSelectedEnglish
                        ? "Reserved Seat:"
                        : language.reservedSeat}
                    </p>
                    <div></div>
                  </div>
                  <div className="emptySeat3">
                    <p>
                      {languageSelectedEnglish
                        ? "Selected Seat:"
                        : language.selectedSeat}
                    </p>
                    <div></div>
                  </div>
                </div>
                <div className="topEnterSeats">
                  <p>
                    {languageSelectedEnglish
                      ? "Please select your Seats Below:"
                      : language.pleaseSelectYourSeatsBelow}
                  </p>
                  {/* <input
                placeholder="Enter number of the seats"
                type="number"
                onChange={handleChangeSeats}
              /> */}
                </div>
                <div className="steering-wheel">
                  <TbSteeringWheel style={{ fontSize: "40px" }} />
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <Grid
              container
              className="mapWrapper"
              align="center"
              justifyContent="center"
            >
              {props?.seatSelection ? (
                <div
                  id="seat-map"
                  className="seatCharts-container"
                  tabIndex="0"
                  aria-activedescendant="2_2"
                >
                  {arraytwo?.map((item, i) => {
                    if (i % 4 === 0) {
                      const remainingSeats = arraytwo.length - i;

                      return (
                        <div className="seat-row" key={`row-${i / 4}`}>
                          <div className="seat-group left">
                            {arraytwo
                              .slice(i, i + Math.min(2, remainingSeats))
                              .map((seat, index) => {
                                const isReserved = occupiedSeats.includes(
                                  seat.seatNo
                                );
                                return (
                                  <div
                                    className={`seatOuter ${
                                      seat.flag ? "seat-selected" : ""
                                    } ${
                                      isReserved
                                        ? "reserved-seat"
                                        : "empty-seat"
                                    }`}
                                    onClick={
                                      seat?.flag
                                        ? () =>
                                            seatSelectedClicked(
                                              i + index,
                                              seat,
                                              occupiedSeats
                                            )
                                        : !isReserved
                                        ? () =>
                                            seatSelectedClicked(
                                              i + index,
                                              seat,
                                              occupiedSeats
                                            )
                                        : null
                                    }
                                    key={index}
                                  >
                                    <div className="seat-wrapper">
                                      {seat.seatNo}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                          <div className="seat-group right">
                            {arraytwo
                              .slice(
                                i + 2,
                                i + 2 + Math.min(2, remainingSeats - 2)
                              )
                              .map((seat, index) => {
                                const isReserved = occupiedSeats.includes(
                                  seat.seatNo
                                );
                                return (
                                  <div
                                    className={`seatOuter ${
                                      seat.flag ? "seat-selected" : ""
                                    } ${
                                      isReserved
                                        ? "reserved-seat"
                                        : "empty-seat"
                                    }`}
                                    onClick={
                                      seat?.flag
                                        ? () =>
                                            seatSelectedClicked(
                                              i + index,
                                              seat,
                                              occupiedSeats
                                            )
                                        : !isReserved
                                        ? () =>
                                            seatSelectedClicked(
                                              i + index,
                                              seat,
                                              occupiedSeats
                                            )
                                        : null
                                    }
                                    key={index}
                                  >
                                    <div className="seat-wrapper">
                                      {seat.seatNo}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              ) : (
                <input
                  type="number"
                  value={inputselectedSeats}
                  readOnly
                  className="inputselectedSeats"
                  placeholder={
                    languageSelectedEnglish
                      ? "Number of Seats"
                      : language.numberOfSeats
                  }
                />
              )}
            </Grid>
          </Grid>

          <Grid
            item
            xl={5}
            lg={5}
            md={12}
            xs={12}
            className="priceSection"
            style={{ padding: "20px 0" }}
          >
            <Grid item xs={12} className="container">
              <p className="heading">
                {languageSelectedEnglish
                  ? "Booking Details"
                  : language.bookingDetails}
              </p>
              <p className="seatNo">
                {languageSelectedEnglish
                  ? "Selected Seats"
                  : language.selectedSeat}{" "}
                (
                {props.seatSelection
                  ? selectedSeats.length
                  : inputselectedSeats === null
                  ? 0
                  : inputselectedSeats}
                ):
              </p>
              {/* <ul className="seatDetails">
                <li className="individualSeat">Seat # 1</li>
                <li className="individualSeat">Seat # 9</li>
              </ul> */}
            </Grid>
            <Grid item xs={12} className="fare">
              <p className="finalPrice">
                {props.isPackage ? "Fare with Accommodation:" : "Total Fare:"}
                <span>
                  <strong>
                    {props.isPackage && props.trip?.priceOptions[0].active
                      ? selectedSeats.length *
                        props.trip.priceOptions[0].priceWith
                      : selectedSeats.length * props.busPrice}
                  </strong>
                </span>
              </p>
            </Grid>
            {props.isPackage && props.trip?.priceOptions[1].active && (
              <Grid item xs={12} className="fare">
                <p className="finalPrice">
                  Fare without Accommodation:
                  <span>
                    <strong>
                      {selectedSeats.length *
                        props.trip.priceOptions[1].priceWithout}
                    </strong>
                  </span>
                </p>
              </Grid>
            )}

            {props.isPackage && props.trip?.priceOptions[2].active && (
              <Grid item xs={12} className="fare">
                <p className="finalPrice">
                  Fare with Food & Accommodation:
                  <span>
                    <strong>
                      {selectedSeats.length *
                        props.trip.priceOptions[2].priceWithAcomFood}
                    </strong>
                  </span>
                </p>
              </Grid>
            )}

            {props.isPackage && props.trip?.priceOptions[3].active && (
              <Grid item xs={12} className="fare">
                <p className="finalPrice">
                  Fare with Visa, Food & Accommodation:
                  <span>
                    <strong>
                      {selectedSeats.length *
                        props.trip.priceOptions[3].priceWithVisaAcomFood}
                    </strong>
                  </span>
                </p>
              </Grid>
            )}

            <Grid item xs={12} className="btnWrap">
              {/* <Link to="/client/passenger-detail"> */}
              {requestTripType !== "Round Trip" && !props.isPackage && (
                <Link
                  onClick={() => nextClicked()}
                  to={{
                    pathname: props.modifyTrip
                      ? "/client/checkout"
                      : "/client/passenger-detail",
                  }}
                >
                  <button>
                    {languageSelectedEnglish ? "Next" : language.next}
                  </button>
                </Link>
              )}
              {requestTripType == "Round Trip" && (
                <button
                  className="result-each-seats-button w-full mt-1"
                  onClick={() => SelectedTrip(props.trip)}
                >
                  <button>
                    {languageSelectedEnglish ? "Confirm" : language.next}
                  </button>
                </button>
              )}
              {props.isPackage && props.trip?.priceOptions[0].active && (
                <Grid item xs={12} className="btnWrap">
                  <button
                    className="result-each-seats-button w-full mt-1"
                    onClick={() => SelectedPackage(props.trip, "with")}
                  >
                    With Accommodation
                  </button>
                </Grid>
              )}
              {props.isPackage && props.trip?.priceOptions[1].active && (
                <Grid item xs={12} className="btnWrap">
                  <button
                    className="result-each-seats-button w-full mt-1"
                    onClick={() => SelectedPackage(props.trip, "without")}
                  >
                    Without Accommodation
                  </button>
                </Grid>
              )}
              {props.isPackage && props.trip?.priceOptions[2].active && (
                <Grid item xs={12} className="btnWrap">
                  <button
                    className="result-each-seats-button w-full mt-1"
                    onClick={() => SelectedPackage(props.trip, "food")}
                  >
                    with Food & Accommodation
                  </button>
                </Grid>
              )}

              {props.isPackage && props.trip?.priceOptions[3].active && (
                <Grid item xs={12} className="btnWrap">
                  <button
                    className="result-each-seats-button w-full mt-1"
                    onClick={() => SelectedPackage(props.trip, "Visa")}
                  >
                    with Visa, Food & Accommodation
                  </button>
                </Grid>
              )}

              {/* </Link> */}
            </Grid>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid item xs={12} className="tableWrapper">
          <table className="cancellationTable">
            <thead className="cancellationHead">
              <tr className="cancellationRow">
                <th className="cancellation">
                  {languageSelectedEnglish
                    ? "Hours before Departure"
                    : language.hoursBeforeDeparture}
                </th>
                <th className="cancellation">
                  {languageSelectedEnglish
                    ? "Refund Percentage"
                    : language.refundPercentage}
                </th>
              </tr>
            </thead>
            <tbody className="tableBody">
              <tr className="tableRow">
                <td className="cancellation">
                  {languageSelectedEnglish ? "Before" : language.before} 0 Hrs.
                </td>
                <td className="cancellation">0%</td>
              </tr>
              <tr className="tableRow">
                <td className="cancellation">
                  {languageSelectedEnglish ? "Before" : language.before} 24 Hrs.
                </td>
                <td className="cancellation">30%</td>
              </tr>
              <tr className="tableRow">
                <td className="cancellation">
                  {languageSelectedEnglish ? "Before" : language.before} 48 Hrs.
                </td>
                <td className="cancellation">60%</td>
              </tr>
              <tr className="tableRow">
                <td className="cancellation">
                  {languageSelectedEnglish ? "Before" : language.before} 60 Hrs.
                </td>
                <td className="cancellation">75%</td>
              </tr>
              <tr className="tableRow">
                <td className="cancellation">
                  {languageSelectedEnglish ? "Above" : language.above} 60 Hrs.
                </td>
                <td className="cancellation">80%</td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} className="policy">
          <p className="heading">
            {languageSelectedEnglish
              ? "Terms & Conditions"
              : language.termsConditions}
          </p>
          <ul className="policyListing">
            <li className="list">
              {languageSelectedEnglish
                ? "The penalty is subject to 24 hrs before departure. No Changes are allowed after that."
                : language.thePenaltyIsSubject}
            </li>
            <li className="list">
              {languageSelectedEnglish
                ? "The charges are per seat."
                : language.theChargesArePerSeat}
            </li>
            <li className="list">
              {languageSelectedEnglish
                ? "Partial cancellation is not allowed on tickets booked under special discounted fares."
                : language.partialCancellationIsNotAllowed}
            </li>
            <li className="list">
              {languageSelectedEnglish
                ? " In case of no-show or ticket not cancelled within the stipulated time, only statutory taxes are refundable subject to Service Fee."
                : language.inCaseOfNoShowOrTicket}
            </li>
          </ul>
        </Grid>
      </TabPanel>
    </>
  );
};
export default BasicTabs;
